import type { Keeper } from '@pff-consumer/schema/fantasy-live-draft/keeper'

export const getTeamKeepers = (leagueKeepers: Keeper[], teamName: string): string[] => {
  return leagueKeepers
    .filter((keeper) => keeper.drafteeName.toLowerCase() === teamName.toLowerCase())
    .map((team) => team.playerId)
}
